/**
 * Récupère la valeur d'un objet à un chemin donné (notation pointée)
 */
export function getNestedValue(obj: Record<string, any>, path: string): any {
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

/**
 * Définit la valeur d'un objet à un chemin donné (notation pointée)
 */
export function setNestedValue(obj: Record<string, any>, path: string, value: any): Record<string, any> {
  const keys = path.split(".");
  const lastKey = keys.pop()!;
  const deep = keys.reduce((acc, key) => {
    if (!acc[key]) acc[key] = {};
    return acc[key];
  }, obj);
  deep[lastKey] = value;
  return obj;
}
